import { jsxs as B, jsx as I } from "react/jsx-runtime";
import { c as l } from "./index-65016bfa.mjs";
import { forwardRef as ct, useRef as ut } from "react";
import p, { css as r } from "styled-components";
import "@fcamna/shared-component-foundations";
import { u as et } from "./useQuantum-50e8fd44.mjs";
import "./isClient-ec947a14.mjs";
import "./useSlots-a1aa6a84.mjs";
import { I as e, H as ot } from "./helperText-d9646f54.mjs";
import { L as mt } from "./label-33699561.mjs";
import { u as It } from "./useAccessibilityProps-2f24cf29.mjs";
import "./setup-0f23222d.mjs";
import "./table.js";
import { u as lt } from "./uniqueId-321287e8.mjs";
import "./_commonjsHelpers-92157f1b.mjs";
import "./icon.js";
import "@fcamna/shared-icons";
import "./popupTip.js";
import "react-dom";
import "./usePopoverIndex-b3a93ecd.mjs";
import "./Aria-f5e019e2.mjs";
import "./useWindowSize-88e90e04.mjs";
import "./button.js";
import "./closeButton.js";
import "./iconButton.js";
import "./divider.js";
import "./focusTrap.js";
import "./useClient-0bbce34e.mjs";
import "./getElementPosition-a8642645.mjs";
import "./link.js";
import "./tooltip.js";
const pt = "TextInput", rt = p.div`
  &.TextInput-wrapper {
    ${({
  theme: {
    components: { textInput: a }
  }
}) => r(a.TextInputWrapper)};
  }
`, ft = p(mt)`
  &.TextInput__label {
    ${({
  theme: {
    components: { textInput: a }
  }
}) => r(a.InputLabel)};
  }
`, _t = p.div`
  &.TextInput__input-container {
    ${({
  theme: {
    components: { textInput: a }
  }
}) => r(a.InputContainer)};
  }
`, dt = p.input`
  &.TextInput__input {
    ${({
  theme: {
    components: { textInput: a }
  }
}) => r(a.BaseTextInput)};
  }
`, D = p.div`
  &.TextInput__adornment {
    ${({
  theme: {
    components: { textInput: a }
  }
}) => r(a.AdornmentWrapper)};
  }
`, Zt = ct(
  ({
    startAdornment: a,
    endAdornment: y,
    startAdornmentProp: i,
    endAdornmentProp: n,
    defaultValue: W,
    disabled: u,
    isInvalid: H,
    showErrorIcon: yt = !0,
    placeholder: j = "Placeholder",
    helperText: F,
    value: S,
    isRequired: N = !1,
    required: f = N,
    inputRef: M,
    className: Q,
    success: V,
    label: X,
    showRequiredIndicator: q = f,
    pattern: z,
    textSize: G = "medium",
    children: Nt,
    infoText: J,
    infoType: K = "tooltip",
    popupTipHeader: U = "Info",
    optionalText: Y,
    labelProp: b = {
      label: X
    },
    infoProp: Z = {
      infoText: J,
      infoType: K,
      popupTipHeader: U
    },
    helperTextProp: o,
    trailingText: h,
    accessibilityOptions: A = {},
    inputState: x,
    trailingElement: P,
    ..._
  }, tt) => {
    var E, T, g, O, C, L, R, w, k, v;
    const at = et({ label: "Text Input" }), m = ut(lt(pt)), $ = `${m.current}_label_id`;
    let s = x || e.NONE, t = o;
    x || (s = H ? e.ERROR : e.NONE), o ? (s === e.NONE && (s = ((E = o.secondaryProp) == null ? void 0 : E.state) || e.NONE), t = {
      ...o,
      secondaryProp: {
        ...o.secondaryProp,
        state: s
      }
    }) : t = {
      [s === e.NONE ? "defaultProp" : "secondaryProp"]: {
        helperText: F,
        state: s
      }
    };
    const c = {
      defaultId: ((T = t == null ? void 0 : t.defaultProp) == null ? void 0 : T.id) || `default_${m.current}_message_id`,
      secondaryId: ((g = t == null ? void 0 : t.secondaryProp) == null ? void 0 : g.id) || `secondary_${m.current}_message_id`
    }, it = !!((C = (O = t == null ? void 0 : t.defaultProp) == null ? void 0 : O.helperText) != null && C.trim().length), nt = !!((R = (L = t == null ? void 0 : t.secondaryProp) == null ? void 0 : L.helperText) != null && R.trim().length) && ((w = t == null ? void 0 : t.secondaryProp) == null ? void 0 : w.state) !== e.NONE;
    let d = b.label ? $ : "";
    it && (d += ` ${c == null ? void 0 : c.defaultId}`), nt && (d += ` ${c == null ? void 0 : c.secondaryId}`);
    const st = It("input", {
      ariaDisabled: u,
      ariaInvalid: ((k = t == null ? void 0 : t.secondaryProp) == null ? void 0 : k.state) === "caution" || ((v = t == null ? void 0 : t.secondaryProp) == null ? void 0 : v.state) === "error",
      ariaRequired: N || f,
      ariaLabelledBy: d,
      ...A
    });
    return /* @__PURE__ */ B(
      rt,
      {
        ref: tt,
        className: l(["TextInput-wrapper", Q]),
        ...at,
        children: [
          /* @__PURE__ */ I(
            ft,
            {
              className: l(["TextInput__label", { "TextInput__label--disabled": u }]),
              labelProp: {
                showRequiredIndicator: q,
                success: V,
                id: $,
                htmlFor: _.id || m.current,
                ...b
              },
              infoProp: {
                infoText: "",
                infoType: "tooltip",
                popupTipHeader: "Info",
                ...Z
              },
              trailingElement: P,
              trailingText: Y || h
            }
          ),
          /* @__PURE__ */ B(
            _t,
            {
              className: l([
                "TextInput__input-container",
                `TextInput__input-container--${G}`,
                `TextInput__input-container--${s || "none"}`,
                { "TextInput__input-container--disabled": u }
              ]),
              "data-trigger": "true",
              tabIndex: -1,
              children: [
                (a || (i == null ? void 0 : i.startAdornment)) && /* @__PURE__ */ I(
                  D,
                  {
                    className: l([
                      "TextInput__adornment",
                      "TextInput__adornment--start",
                      { "TextInput__adornment--disabled": u }
                    ]),
                    onClick: i == null ? void 0 : i.onClick,
                    children: a || (i == null ? void 0 : i.startAdornment)
                  }
                ),
                /* @__PURE__ */ I(
                  dt,
                  {
                    disabled: u,
                    value: S,
                    placeholder: j,
                    defaultValue: W,
                    ref: M,
                    id: _.id || m.current,
                    required: f,
                    pattern: z,
                    ...st,
                    ..._,
                    className: "TextInput__input"
                  }
                ),
                (y || (n == null ? void 0 : n.endAdornment)) && /* @__PURE__ */ I(
                  D,
                  {
                    className: l(["TextInput__adornment", "TextInput__adornment--end", { "TextInput__adornment--disabled": u }]),
                    onClick: n == null ? void 0 : n.onClick,
                    children: y || (n == null ? void 0 : n.endAdornment)
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ I(
            ot,
            {
              secondaryProp: {
                id: c.secondaryId,
                ...t == null ? void 0 : t.secondaryProp,
                state: s
              },
              defaultProp: { id: c.defaultId, ...t == null ? void 0 : t.defaultProp },
              disabled: u
            }
          )
        ]
      }
    );
  }
);
export {
  Zt as TextInput
};
